import type { FC, PropsWithChildren } from 'react'

import mascotRestrict from 'assets/image/snail-no.png'
import clsx from 'clsx'
import { useLinkedInInfo } from 'components/molecules/linkedInNotLogged/useLinkedInInfo'
import { CONSTS } from 'config/objectConst'
import { useLinkedInReauth } from 'features/linkedin-login/LinkedInReauthProvider'
import { Link } from 'react-router-dom'
import { Button } from 'shared/ui'

import css from './Unavailable.module.css'

const rootCN = clsx(css.root, 'main app-scroll')
export const Unavailable: FC<
	PropsWithChildren<{ imagePlacement?: 'end' | 'start' }>
> = ({ children, imagePlacement = 'end' }) => (
	<figure className={rootCN}>
		<figcaption className={css.text}>{children}</figcaption>

		<img
			alt={`${CONSTS.PROJECT_NAME} say: "You shall not pass"`}
			className={clsx(css.pic, imagePlacement === 'start' && css.picTop)}
			height={209}
			src={mascotRestrict}
			width={120}
		/>
	</figure>
)

function UnavailableLinkedIn() {
	const { id, linkedInfo } = useLinkedInInfo()
	return (
		<Unavailable>
			Mailbox is unavailable while you are not log in to LinkedIn <br />
			with{' '}
			{linkedInfo ? (
				<a
					className={css.link}
					href={`https://www.linkedin.com/in/${id}/`}
					rel='noopener noreferrer'
					target='_blank'
				>
					{`${linkedInfo.givenName} ${linkedInfo.familyName} account.`}
				</a>
			) : (
				'account.'
			)}
		</Unavailable>
	)
}

const UnavailableSubscription = () => (
	<Unavailable imagePlacement='start'>
		Messaging is unavailable because your subscription is expired
		<Button as={Link} className={css.upgrade} to='/upgrade'>
			Upgrade subscription
		</Button>
	</Unavailable>
)

const RemoteAutomationUnavailable = () => (
	<Unavailable>
		Messaging in remote mode is only available for users with PRO/TEAM
		subscriptions.
		<br />
		Consider to upgrade subscription.
	</Unavailable>
)

const ProxyIssue = () => (
	<Unavailable>
		There are temporary technical issues with internet proxy.
		<br />
		It will be automatically solved soon. Please, try again later.
	</Unavailable>
)
function LinkedInMemberIssue() {
	const { start } = useLinkedInReauth()

	return (
		<Unavailable>
			This workspace is not signed in to the linked LinkedIn account.
			<br />
			<Button className={css.upgrade} onClick={start} type='button'>
				Sign in to LinkedIn
			</Button>
		</Unavailable>
	)
}

export {
	LinkedInMemberIssue,
	ProxyIssue,
	RemoteAutomationUnavailable,
	UnavailableLinkedIn,
	UnavailableSubscription
}
